import { ReactElement, useCallback, useRef } from 'react';

import useOnOffState from 'hooks/common/useOnOffState';

import { CampaignCreationWizardBackAlert } from 'components/CampaignCreationWizardFlow/CampaignCreationWizardBackAlert';

interface CampaignCreationWizardBackAlertState {
    backAlert: ReactElement;
    openBackAlert: (onConfirm: () => void) => void;
}

export const useCampaignCreationWizardBackAlert = (): CampaignCreationWizardBackAlertState => {
    const [isVisible, showAlert, hideAlert] = useOnOffState(false);
    const pendingConfirmRef = useRef<(() => void) | null>(null);

    const openBackAlert = useCallback(
        (onConfirm: () => void) => {
            pendingConfirmRef.current = onConfirm;
            showAlert();
        },
        [showAlert]
    );

    const handleConfirm = useCallback(() => {
        hideAlert();
        pendingConfirmRef.current?.();
    }, [hideAlert]);

    const backAlert = (
        <CampaignCreationWizardBackAlert visible={isVisible} onClose={hideAlert} onConfirm={handleConfirm} />
    );

    return { backAlert, openBackAlert };
};
